import type { MyPageLink } from '../types'

export const buildMyPageLink = (
  baseUrl: string,
  slug: string | null | undefined,
): MyPageLink | null => (slug ? { slug, url: `${baseUrl}/${slug}` } : null)
